/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const HouseRegularV6 = (props) => (
  <Icon {...props} name="House Regular V6">
    <path d="M15.764 7.269a.665.665 0 1 1-.861 1.017l-.681-.578v5.181A2.22 2.22 0 0 1 12 15.111H4a2.222 2.222 0 0 1-2.222-2.222V7.708l-.68.578a.666.666 0 0 1-.863-1.017l7.334-6.222a.665.665 0 0 1 .861 0l7.333 6.222zM4 13.778h1.333V9.556a1.11 1.11 0 0 1 1.111-1.111h3.111a1.11 1.11 0 0 1 1.111 1.111v4.222h1.333a.888.888 0 0 0 .889-.889V6.578L7.999 2.43 3.11 6.578v6.311c0 .492.397.889.889.889zm2.667 0h2.667v-4H6.667v4z" />
  </Icon>
);

export default HouseRegularV6;
